import React from 'react';
import Aux from '../utils/Aux';

import NewForm from './FormSettings/NewForm';
import EditForm from './FormSettings/EditForm';
import CopyForm from './CopyForm';
import DeleteForm from './DeleteForm';
import SaveForm from './SaveForm';
import EditWarning from './EditWarning';
import Notifications from './Notifications';
import { dialogs } from '../../store/dialogs/actions';

function RenderDialogs () {
    return (
        <Aux>
            <NewForm dialogName={dialogs.newForm} />
            <EditForm dialogName={dialogs.editForm} />
            <CopyForm dialogName={dialogs.copyForm} />
            <DeleteForm dialogName={dialogs.deleteForm} />
            <SaveForm dialogName={dialogs.saveForm} />
            <EditWarning dialogName={dialogs.editWarning} />
            <Notifications />
        </Aux>
    );
}

export default RenderDialogs;
